import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { requestCandidateDetailAccess } from "../../../../../endpoints/referral.service";
import Button from "../../../../../components/button/button";
import { colors } from "../../../../../utils/theme";

const RestrictedContent = ({ candidateId, detailSection }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { watch, setValue } = useForm({
    defaultValues: {
      isLoading: false,
      isRequested: false,
    },
  });

  const fields = watch();

  const sendRequest = async () => {
    try {
      setValue("isLoading", true);
      await requestCandidateDetailAccess({
        candidateId,
        detailSection,
      });
      setValue("isRequested", true);
      enqueueSnackbar("Request sent successfully!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      const timer = setTimeout(() => {
        setValue("isRequested", false);
        clearTimeout(timer);
      }, 2500);
      setValue("isLoading", false);
    }
  };

  return (
    <div className="flex flex-col gap-4 px-6">
      <span className=" text-primary text-center items-center font-semibold text-sm">
        You don't have permission to view this. Please ask the candidate to
        enable access for you.
      </span>
      <Button
        className="self-center"
        style={{
          paddingLeft: 24,
          paddingRight: 24,
          opacity: fields?.isLoading ? 0.5 : 1,
        }}
        color={!fields?.isRequested ? colors.Green : colors?.PrimaryBlack}
        disabled={fields?.isLoading || fields?.isRequested}
        onClick={sendRequest}
      >
        {fields?.isRequested ? "Requested" : "Request Access"}
      </Button>
    </div>
  );
};

export default RestrictedContent;
